import React, { useCallback } from 'react';
import { connect } from 'formik';
import PropTypes from 'prop-types';
import { Grid, MenuItem } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { GridItem } from '~/modules/common/components';
import FormSelectField from '~/modules/common/components/FormSelectField';
import { ProjectTeamMemberAssignmentType } from '~/types';

export const EditProjectSettingsForm = ({
  formik: { values, setFieldValue }
}) => {
  const { formatMessage } = useIntl();
  const handleChange = useCallback(
    event => {
      setFieldValue('projectTeamMemberAssignmentType', event.target.value);
    },
    [setFieldValue]
  );

  return (
    <Grid container>
      <GridItem fullWidth>
        <FormSelectField
          label={formatMessage({
            id: 'projectSettingsCard.whenAddingTeamMembers'
          })}
          value={values.projectTeamMemberAssignmentType}
          onChange={handleChange}
          variant="outlined"
          dataQeId="ProjectTeamMemberAssignmentTypeDropdown"
        >
          <MenuItem value={ProjectTeamMemberAssignmentType.ManuallyAssignTask}>
            {formatMessage({ id: 'projectSettingsCard.manuallyAssignTask' })}
          </MenuItem>
          <MenuItem
            value={ProjectTeamMemberAssignmentType.AutomaticallyAssignTask}
          >
            {formatMessage({
              id: 'projectSettingsCard.automaticallyAssignTask'
            })}
          </MenuItem>
        </FormSelectField>
      </GridItem>
    </Grid>
  );
};

EditProjectSettingsForm.propTypes = {
  formik: PropTypes.object
};

export default connect(EditProjectSettingsForm);
